import { render, staticRenderFns } from "./CalloutCardPreview.vue?vue&type=template&id=3f0f2ae7&scoped=true"
import script from "./CalloutCardPreview.vue?vue&type=script&lang=js"
export * from "./CalloutCardPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0f2ae7",
  null
  
)

export default component.exports